import { APIGetDevices, APIGetV3Payload } from '../../../config/restAPI/FetchAPI';
import { resolveDeviceTotalMileageKm } from '../../../component/assetDetailsCard/telemetrySourceData';

/**
 * Resolve live total mileage (km) for a device — same source as Live map "Total Mileage".
 * Used by maintenance report form defaults and compliance tab current mileage display.
 */
export async function fetchDeviceTotalMileageKmForAsset(
  token,
  agencyID,
  assetId,
  mileageSourceHint = null,
) {
  if (!assetId || !token || !agencyID) return null;

  let mileageSource = mileageSourceHint ?? null;
  try {
    const deviceResult = await APIGetDevices(() => {}, token, agencyID, {
      oid: assetId,
      pageNumber: 1,
      totalPerPage: 1,
    });
    if (deviceResult?.data?.status === 200) {
      const [device] = deviceResult?.data?.data || [];
      if (device?.mileageSource != null) {
        mileageSource = device.mileageSource;
      }
    }

    const payloadResult = await APIGetV3Payload(() => {}, token, agencyID, assetId);
    if (payloadResult?.data?.status !== 200) return null;

    const payloadData = payloadResult?.data?.data;
    const latest = Array.isArray(payloadData) ? payloadData[0] : payloadData;
    return resolveDeviceTotalMileageKm(latest, mileageSource);
  } catch {
    return null;
  }
}
